import { render, staticRenderFns } from "./NormalSearchNav227.vue?vue&type=template&id=4e36c646&scoped=true"
import script from "./NormalSearchNav227.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav227.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e36c646",
  null
  
)

export default component.exports